export function castStringToInteger(val: string): number {
  return Number.parseInt(val, 10);
}
